import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { Multimedia } from '@web/shared/module/multimedia';
import { Icon, IconComponent, ImageThumbnailComponent } from '@web/shared/ui';
import { Tooltip } from 'primeng/tooltip';
import { PublicBrandCosmeticBox } from '@web/shared/module/brand';

@Component({
  selector: 'app-public-brand-cosmetics-tile',
  imports: [
    IconComponent,
    RouterLinkComponent,
    Tooltip,
    ImageThumbnailComponent,
    NgOptimizedImage,
  ],
  templateUrl: './public-brand-cosmetics-tile.component.html',
  styleUrl: './public-brand-cosmetics-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandCosmeticsTileComponent {
  public readonly boxes = input<PublicBrandCosmeticBox[]>([]);
  public readonly image = input.required<Multimedia>();
  public readonly name = input.required<string>();
  public readonly slug = input.required<string>();
  public readonly routerLinkParams = this.routerLinkParamsSignal();

  protected readonly Route = Route;
  protected readonly Icon = Icon;

  protected prepareBoxParams(box: PublicBrandCosmeticBox): RouterLinkParams {
    return {
      [RouteParam.Slug]: box.slug,
    };
  }

  private routerLinkParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Slug]: this.slug(),
    }));
  }
}
